module.exports = __webpack_public_path__ + "de0ce9e6b90e8cea1345d710b5adc33a.jpg";